<template>
  <div class="homeNav">
    <div class="homeNav-main">
<!--      2A82E4FF-->
      <el-menu
          style="color: #fff;font-size: 18px;"
          :default-active="$route.path"
          class="el-menu-demo sm-font"
          mode="horizontal"
          @select="handleSelect"
          text-color="#333"
          active-text-color="#2A82E4FF">
<!--        background-color="#2A82E4"-->
        <div class="el-menu-container">
        <el-menu-item index="/">首页</el-menu-item>
        <el-submenu index="/resourceBase" class="second-menu">
          <template slot="title">资源</template>
          <el-submenu index="/resourceBase/germplasm">
            <template slot="title">种质资源</template>
            <el-menu-item index="/resourceBase/germplasm/seed">种子</el-menu-item>
            <el-menu-item index="/resourceBase/germplasm/dna">DNA</el-menu-item>
            <el-menu-item index="/resourceBase/germplasm/driedLeaf">干燥叶片</el-menu-item>
            <el-menu-item index="/resourceBase/germplasm/germplasmAnimal">动物种质</el-menu-item>
          </el-submenu>
          <el-submenu index="/resourceBase/dnaBar">
            <template slot="title">DNA条形码</template>
            <el-menu-item index="/resourceBase/dnaBar/spineAnimal">脊椎动物</el-menu-item>
            <el-menu-item index="/resourceBase/dnaBar/vascularPlant">维管植物 (植物)</el-menu-item>
          </el-submenu>
          <el-submenu index="/resourceBase/list">
            <template slot="title">名录</template>
            <el-menu-item index="/resourceBase/list/protectList">高黎贡山国家重点保护野生植物名录</el-menu-item>
            <el-menu-item index="/resourceBase/list/uniqueList">高黎贡山特有植物名录</el-menu-item>
            <el-menu-item index="/resourceBase/list/wildPlants">怒江州高黎贡山野生植物名录</el-menu-item>
            <el-menu-item  index="/resourceBase/list/terrestrialWildlife">怒江州高黎贡山陆生野生动物（脊椎动物）</el-menu-item>
<!--            <el-menu-item @click="clickHandle('怒江州高黎贡山野生植物名录',1)">怒江州高黎贡山野生植物名录</el-menu-item>-->
<!--            <el-menu-item @click="clickHandle('怒江州高黎贡山陆生野生动物（脊椎动物）',2)" >怒江州高黎贡山陆生野生动物（脊椎动物）</el-menu-item>-->
            <el-menu-item index="/resourceBase/list/protectedWildPlants">高黎贡山-伯舒拉岭重点保护野生植物名录</el-menu-item>
          </el-submenu>
          <el-submenu index="/resourceBase/workGuide">
            <template slot="title">工作指南</template>
            <el-menu-item index="/resourceBase/workGuide/management">种质资源采集和管理规范</el-menu-item>
            <el-menu-item index="/resourceBase/workGuide/filling">野外数据填写规范 (植物)</el-menu-item>
          </el-submenu>
        </el-submenu>
        <el-submenu index="/dynamic" class="second-menu">
          <template slot="title">动态</template>
          <el-menu-item index="/dynamic/information">动态资讯</el-menu-item>
          <el-menu-item index="/dynamic/progressWork">工作进展</el-menu-item>
        </el-submenu>
        <el-submenu index="/scientificResearch" class="second-menu">
          <template slot="title">科考影像</template>
          <el-menu-item index="/scientificResearch/picture">图片</el-menu-item>
          <el-menu-item index="/scientificResearch/video">视频</el-menu-item>
        </el-submenu>
        <el-submenu index="/help" class="second-menu">
          <template slot="title">帮助</template>
          <el-menu-item index="/help/problem" class="second-menu-item">常见问题</el-menu-item>
          <el-menu-item index="/help/relationWe" class="second-menu-item">联系我们</el-menu-item>
        </el-submenu>
        </div>
      </el-menu>

    </div>
    <div>
      <el-dialog
          :title="title" :close-on-click-modal="false"
          :visible.sync="dialogVisible"
          width="30%">
        <div v-if="tag === 1" v-for="(file,fileIndex) in prefectureWildPlants" :key="fileIndex"
             style="display: flex;justify-content: center">
          <el-link @click="handDownloadFile(file)"><i class="el-icon-document"></i>{{file.name}}<i class="el-icon-download el-icon--right"></i> </el-link>
        </div>
        <div v-if="tag === 2" v-for="(file,fileIndex) in terrestrialWildlife" :key="fileIndex"
             style="display: flex;justify-content: center">
          <el-link @click="handDownloadFile(file)"><i class="el-icon-document"></i>{{file.name}}<i class="el-icon-download el-icon--right"></i> </el-link>
        </div>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import { getOtherFile } from '../../network/common'
import { FileDown } from '../../utils/util'
// import { FileDown } from '../../network/common'
export default {
  name: "homeNav",
  data() {
    return {
      dialogVisible: false,
      title: '',
      pvId: 0,
      type: 'nujiangPrefectureWildPlants',
      type2: 'terrestrialWildlife',
      prefectureWildPlants: [],
      terrestrialWildlife: [],
      tag: 0,
    }
  },
  methods: {
    handleSelect(key, keyPath) {
      this.$router.push({path:key}).catch(err => {
        // console.log(err)
      })
    },
    clickHandle(val,i) {
      this.tag = i
      this.dialogVisible = true
      // console.log(val)
      this.title = val
      if(i === 1) {
        getOtherFile(this.pvId,this.type).then(res=>{
          // console.log(res)
          this.prefectureWildPlants = res.data.data
        })
      } else if(i === 2) {
        getOtherFile(this.pvId,this.type2).then(res=>{
          // console.log(res)
          this.terrestrialWildlife = res.data.data
        })
      }

    },
    handDownloadFile(row) {
      // console.log(row)
      FileDown(row.bucketName, row.fileName, row.name).then(res => {})
    },

  }
}
</script>

<style scoped lang="scss">
.el-dropdown-menu__item, .el-menu-item {
  font-size: 15px !important;
}
::v-deep .el-menu-item {
  color: #fff !important;
}
::v-deep .el-menu--horizontal>.el-menu-item:not(.is-disabled):focus, .el-menu--horizontal>.el-menu-item:not(.is-disabled):hover, .el-menu--horizontal>.el-submenu .el-submenu__title:hover {
  //background-color: rgba(42,130,228) !important;
  background-color: rgba(0,54,115);
}
//.el-menu--popup-bottom-start {
//  background:   #2A82E4 !important;
//  margin: 0px;
//}
//::v-deep .el-menu--popup {
//  background: #2A82E4 !important;
//}
::v-deep .el-menu .el-menu--popup .el-menu--popup-bottom-start {
  background-color: rgba(42,130,228) !important;
}
::v-deep .el-submenu__title {
  font-size: 15px !important;
  color: #333 !important;
  margin-right: 10px !important;
  //i {
  //  color: rgb(255,255,255,1) !important;
  //}
}
::v-deep .el-submenu__title:hover {
  background-color: rgba(0,54,115,0) !important;
  color: #2A82E4 !important;
}
::v-deep .el-menu .el-menu-item {
  color: #333;
}
::v-deep .el-menu .el-menu-item:hover {
  color: #2A82E4 !important;
}
::v-deep .el-menu--horizontal .el-menu .el-menu-item, .el-menu--horizontal .el-menu .el-submenu__title {
  color: #333 !important;
  //padding: 0px 0;
}
::v-deep .el-menu--horizontal .el-menu .el-menu-item, .el-menu--horizontal .el-menu .el-submenu__title:hover {
  //color: #2A82E4 !important;
  max-width: 320px !important;
}
::v-deep.el-menu.el-menu--horizontal {
  background-color: rgba(42,130,228,.5) !important;
  border-bottom: none;
}
::v-deep .el-submenu {
  color: #333 !important;
  //width: 1px;
  margin: 0 20px!important;
}

//::v-deep .el-menu--horizontal .el-menu .el-menu-item, .el-menu--horizontal .el-menu .el-submenu__title:hover {
//  color: #2A82E4 !important;
//}
::v-deep .el-menu--horizontal .el-menu-item:not(.is-disabled):focus, .el-menu--horizontal .el-menu-item:not(.is-disabled):hover {
  color: #2A82E4 !important;
}
::v-deep .el-submenu__icon-arrow {
  right: 0 !important;
}
.homeNav {

position: relative;
  height: 60px;
  //opacity: 0.7;
  .el-dropdown-menu__item, .el-menu-item {
    font-size: 18px !important;
  }
  //.el-submenu__title
  ::v-deep .el-submenu__title {
    font-size: 18px !important;
    //background-color: #2A82E4 !important;
    i {
      color: rgb(255,255,255,1) !important;
    }
  }

  .homeNav-main {
    //-webkit-filter: brightness(50%);
    //filter:brightness(80%);
    //opacity: 0.7 !important;
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    .el-menu-container {
      width: 1200px;
      display: flex;
      margin: 0 auto;
    }
  }
  .second-menu {
    ::v-deep .el-submenu__title {
      font-size: 18px !important;
      color: #fff !important;
      //background-color: rgba(42,130,228) !important;
      i {
        color: rgb(255,255,255,1) !important;
      }
    }
  }
}
@media screen and (max-width: 992px) {
  .homeNav {

    position: relative;
    height: 60px;
    //opacity: 0.7;
    .el-dropdown-menu__item, .el-menu-item {
      font-size: 18px !important;
    }
    //.el-submenu__title
    ::v-deep .el-submenu__title {
      font-size: 18px !important;
      //background-color: #2A82E4 !important;
      i {
        color: rgb(255,255,255,1) !important;
      }
    }

    .homeNav-main {
      //-webkit-filter: brightness(50%);
      //filter:brightness(80%);
      //opacity: 0.7 !important;
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      .el-menu-container {
        width: 100% !important;
        display: flex;
        margin: 0 auto;
      }
    }
    .second-menu {
      ::v-deep .el-submenu__title {
        font-size: 18px !important;
        color: #fff !important;
        //background-color: rgba(42,130,228) !important;
        i {
          color: rgb(255,255,255,1) !important;
        }
      }
    }
  }
}
@media screen and (max-width: 768px) {
  .homeNav {
    display: none;
  }
}
</style>